import React from 'react';
import { Modal, Divider, Button } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';

import ModalHeader from '../../drive/ModalHeader';
import ModalFooter from '../../drive/ModalFooter';
import ContactUsImage from "../../../images/grafix-banner/deactivate.svg";


class DeactivatedWorkspaceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    selectAnotherWorkspace = () => {
        this.props.closeIsActiveModal();
    }
    
    render() {
        


        return (
            <Modal
                className="basicModal"
                open={this.props.isActiveModal}
                size="small"

            >
                <ModalHeader
                    subHeader={`Hello ${this.props.user && this.props.user.firstName}`}
                    subText={ 'This workspace has been deactivated.'} 
                    />
                <Modal.Content className="ModalContent pad_0">
                    <div className="ModalContent">
                        <div ><img src={`${ContactUsImage}`} height="160" alt='' /> </div>
                        <div className={`error_text2`} style={{ color: '#FF931E' }}>Contact Us</div>
                        <span className="error_text3">Get in touch with Account Owner to reactivate your workspace.</span>
                        <br />
                        <Button style={{ marginTop: "7px" }} className="button-submit" onClick={this.selectAnotherWorkspace} >Select another Workspace</Button>
                    </div>
                    <Divider className="mar_0" />
                    <ModalFooter text={
                        <p className="f_10"><strong>What happens to my data? </strong><p>Don't worry all your data is safe. <br /> You can access it once your workspace is reactivated. </p></p>
                    } />
                </Modal.Content>
            </Modal>
        )
    }
}

export default DeactivatedWorkspaceModal;